import { SvgIcon } from "@mui/material";

export default function Peak(props: any) {
  return (
    <SvgIcon {...props}>
      <path d="M23.809 21.689l-10.8-21a1.084 1.084 0 0 0-2.019 0l-10.8 21a1.827 1.827 0 0 0-.044 1.53A1.191 1.191 0 0 0 1.2 24h21.6a1.191 1.191 0 0 0 1.053-.781 1.826 1.826 0 0 0-.044-1.53zM12 1.5L15.857 9h-4.105L9.6 11.69 7.87 9.531zm-10.8 21l6.007-11.681L9.6 13.81l2.648-3.31h4.38l6.172 12z" />
    </SvgIcon>
  );
}
